<script setup>
import {defineProps} from "vue";
import {useRouter} from "vue-router";

const router = useRouter();

const props = defineProps({
    content: Object,
    index: Number,
    mobile: Boolean
});

const classes = props.mobile ? 'mt-4 rounded w-full py-3 text-xs text-white lg:hidden block text-center bg-purple-400' : 'mt-3 min-w-max rounded-full bg-purple-400 px-10 py-3 text-xs text-white hidden lg:block';

function goToPath(id){
    router.push({ name: 'path', params: { id: id } })
}
</script>

<template>
    <button @click="goToPath(props.content.id)" :class="classes" >
        {{  $tt('content_card__button_path') }}
    </button>
</template>

